export default __webpack_public_path__ + "static/media/slider-wilo-3.8e4cf42b.jpg";